module.exports = __webpack_public_path__ + "img/Token_p1.0faa08cc.png";